import React, { useMemo } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import "../styles/InactivityModal.css";

const InactivityModal = React.memo(({ visible, onHide, remainingTime }) => {
  const footerContent = useMemo(() => (
    <div>
      <Button label="Mantener Sesión" icon="pi pi-check" onClick={onHide} className="p-button-text" />
    </div>
  ), [onHide]);

  return (
    <Dialog
      header="Sesión a punto de expirar"
      visible={visible}
      modal
      draggable={false}
      resizable={false}
      footer={footerContent}
      style={{ width: "30vw" }}
      breakpoints={{ "960px": "75vw", "641px": "100vw" }}
      closable={false}
      dismissableMask={false}
      onHide={() => {}}
    >
      <p>
        Tu sesión está a punto de cerrarse debido a la inactividad. Serás desconectado en <b>{remainingTime}</b> segundos.
      </p>
    </Dialog>
  );
});

export default InactivityModal;
